export const HYATT_AUTH_REDIRECT_URL =
  'https://www.hyattexperiences.com/oauth-redirect';
export const HYATT_ACCESS_TOKEN_SESSION_KEY = 'hyattAccessToken';
export const HYATT_ACCESS_TOKEN_EXPIRY_TIME_SESSION_KEY =
  'hyattAccessTokenExpiryTime';
export const HYATT_REDIRECT_ON_LOGIN_LOCAL_KEY =
  'savedRedirectUrlAfterLogInSuccess'; // updating this key requires you to also update code on webflow for this page https://www.hyattexperiences.com/oauth-redirect
